import React, { useEffect, useState } from "react";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

// JS Files

// Others Files
import fileIcon from "../../imgs/file.svg";

const UploadedFileBox = ({
  item,
  setSelectedFile,
  index,
  handleRemoveFileModal,
}) => {
  return (
    <>
      <div className="border border-r-4 rounded-l-lg  border-myorange-400 p-4 flex items-center justify-between">
        <div className="flex items-center">
          <img src={fileIcon} />
          <span className="mr-8 text-mygray-700">{item.name}</span>
        </div>
        <div
          className="flex items-center cursor-pointer text-mygray-600 hover:text-red-400 transition-all"
          onClick={() => {
            // removeFile(index);
            setSelectedFile(index);
            handleRemoveFileModal();
          }}
        >
          <DeleteForeverIcon className="" />
          <span className=" ">حذف</span>
        </div>
      </div>
    </>
  );
};
export default UploadedFileBox;
